import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { CommonService } from '../../../Services/common.service';
import { ConfigSettingService } from '../../../Services/config-setting.service';
import { DataManipService } from '../../../Services/data-manip.service';
import { EncrptDecreptService } from '../../../Services/encrpt-decrept.service';
import { TrailTestModalComponent } from '../../trail-test-modal/trail-test-modal.component';


@Component({
  selector: 'app-test-page',
  templateUrl: './test-page.component.html',
  styleUrls: ['./test-page.component.scss']
})
export class TestPageComponent implements OnInit {
  @ViewChild('testModal', { static: false }) public testModal: ModalDirective;
  @ViewChild('InstructionbeforetestModal', { static: false }) public InstructionbeforetestModal: ModalDirective;


  max: number = 100;
  showWarning: boolean;
  dynamic: number = 1;
  type: string;
  showLoader: boolean = false;
  stacked: any[] = [];
  testLang: string = "";
  prefLang: string = "";
  timer: any = null;
  buttonCaption: string = 'Start';

  subscription: Subscription;
  headers = new HttpHeaders();

  //This is a test level configuration object to enable/disable the buttons(EX: Previous Question,Next Question,Skip) and enable quetion timer on test page.
  testConfigObj = {};
  // messsages = {};
  // guildlines = "";
  UserImage = "";
  // sortBy: string = "";
  selectedUserImage: File;
  showloader: boolean = false;
  showFinishTestBtn: boolean = false;
  submitBtnText: string = "Submit and Next";
  /// Question level timer ///
  // questionTimer;
  /// End question timer ///
  reviewQueList = []; // to show all questions with their answer status
  // reviewQueListBackup: any[] = [];
  testPaperList: any[] = [];
  currentQuesData = {};// currently showing on page.
  detailsForReview = {};
  previousAnswerObj = {};// to compare with current answer. // to check wether changed the answer or not / compare current answewr and previous answer
  previousAnswerForCT = {};// to compare with current answer. // to check wether changed the answer or not / compare current answewr and previous answer
  quesTimeSpent: any;
  quesTimeSpentPer: any;
  modalImage: string = "";/// base64 image which will be show in the movable modal.
  showQuestionsReview: boolean = false;/// show questions result status and when isreviewquestion allowed.
  displayQuesSuccMsg: boolean = false;/// Display question submit success message.
  displayTimedOutMsg: boolean = false;/// Display question timed out message.
  DoNotShowThisPopupAgain: boolean = false;
  showNextQuesBtn: boolean = false;
  showPrevQuesBtn: boolean = false;
  isImplySubmitAnswer: boolean = false;
  setAsDefaltBehaviour: boolean = false;
  checkLanguage: boolean = false;
  beforeSelctedLang: string = "";
  languages = [
    { "value": 'm', "label": 'Marathi', "display": true },
    { "value": 'h', "label": 'Hindi', "display": true },
    { "value": 'e', "label": 'English', "display": true }]
  displayActionButtons: boolean = false;// do not show the acition buttons once question is available.
  /***
  istimetest, showexplanation, skiptime, testid, testname, testtime
   */
  showQuesStatus: boolean = false;
  clickedFrom: string = "";
  length: number = 0;
  showAlerMdlObj = {
    "show": false,
    "msg": "",
    "yesBtnText": "Yes",
    "noBtnText": "No"
  }

  showWarningMdlObj = {
    "show": false,
    "msg": "",
    "yesBtnText": "Yes",
    "noBtnText": "No",
    "cancelBtnText": "",
  };

  showMandatoryMdlObj = {
    "show": false,
    "msg": "All questions are mandatory, please select the answer"
  }
  trasparentmodal = {
    "show": false,
    "msg": ""
  }
  showMdlObj = {
    "show": false,
    "msg": "",
    "emailerror": ""
  }
  showDefaultBehaviourMdlObj = {
    "show": false,
    "yesBtnText": "Done",
    "noBtnText": ""
  };

  styleClassObj = {
    "W": "wrong",
    "S": "skipped",
    "N": "not-Attempted",
    "T": "timeout",
    "R": "right",
    "Y": "attempted"
    // "W": "background-color:#c53c3c",
    // "S": "background-color:#3c8dbc",
    // "N": "background-color:#888",
    // "T": "background-color:#FFB800",
    // "R": "background-color:rgb(184, 0, 230)",
    // "Y": "background-color:#6CA54C"
  }
  // StyleObject = {
  //   "green": "background-color:green",
  //   "red": "background-color:red",
  //   "limitations": 25
  // };
  messsages = {
    "EXCPT": "Something went wrong. Please contact admin",
    "QP001": "All questions are mandatory, please select the answer",
    "QP002": "Please select the answer.",
    "QP003": "Do you want to submit this answer ?",
    "QP004": "You have not Selected any option for this question. Do you want to select ?",
    "QP005": "Sure to skip this question?",
    "QP006": "Do you want to finish the test ?",
    "QP007": "Congratulations !!<br>You have completed the test.",
    "QP008": "Set this as default behaviour",
    "QP009": "Do not show this popup again",
    "QP010": "The question has timed out",
    "QP011": "Last Answer Submitted successfully",
    "QP012": "You have reached last question in the selected criteria",
    "QP013": "Retry not allowed",
    "QP014": "You have run out off time !!!"
  };
  modalCondition: string = "";// we are using one/two modals in multiple scenarion so to manage the functionality of "Yes" and "No" buttons.

  /***
   * "quesSerialAndStatus" object contains the "tetstpattern" and "usertestmapping"
   * tetstpattern   -Serial number and question Ids.
   */
  quesSerialAndStatus = {
    "testpattern": [],
    "usertestmapping": {}
  };
  // test object will store hours, min and second
  testTimer = {
    "hours": "00",
    "minutes": "00",
    "seconds": "00",
    "testremainingtime": 0,
    "testConsumedTime": 0
    // "testTimeRemaining": 0
  };

  // testIntervalValue will store interval method response
  testIntervalValue;
  quesIntervalValue;
  quesTimeRemainig = {
    // "consumedTime": -1,
    "consumedTime": 0,
    "quesTotTime": 0,
    "minute": "00",
    "seconds": "00",
    "PBwidth": {}
  };
  quesStatusCount = {
    "totalQueCount": 0,
    "corrAnsCount": 0,
    "wroAnsCount": 0,
    "attQueCount": 0,
    "notAttQueCount": 0,
    "timeOutQueCount": 0,
    "skipQueCount": 0,
    // "remainingQuesCount": 0
  };

  UserObj = {
    "userid": "",
    "testid": "",
    "sectionid": "1",
    "testpaperid": "",
    "teststatus": "",
    "usertestpaperno": "",
  };

  testType: string = "";//colortest,optionstest
  hideColor: boolean = false;
  tempColorArray = [];
  colorArray = [];
  selectedColors = [];
  tempSelctedColors = "";
  showNextColors: boolean = false;
  colorsAttempt = 0;
  showSubmitColor: boolean = false;
  colorClickCount = -1;
  instrusctionsBeforeTest: boolean = false;
  colorInstructionLabel: string = "Instructions Iteration 1";
  colorIteraionFirst: boolean = true;
  loaderText: string = "We are processing";
  filePath: string = "";
  colorTestInstructions = [];

  @ViewChild('languageConfirmModal', { static: false }) public languageConfirmModal: ModalDirective;

  trialTestObj = null;
  successTestArray: any = [];
  constructor(private encryptService: EncrptDecreptService, private router: Router, private ngbModal: NgbModal, public dataManipSrvc: DataManipService, private commonServices: CommonService, private configSetting: ConfigSettingService) {

  }

  ngOnInit(): void {
    setTimeout(() => {
      this.dataManipSrvc.headerName = "";
    }, 80);

    //this.testLang = this.dataManipSrvc.prefLanguage;
    this.testLang = this.dataManipSrvc.testLangugae;

    setTimeout(() => {
      this.InstructionbeforetestModal.config = {keyboard:false, backdrop: 'static'};
      this.InstructionbeforetestModal.show();
    }, 200);
    // if (this.dataManipSrvc.testType == "optionstest") {
    //   setTimeout(() => {
    //     this.InstructionbeforetestModal.show();
    //   }, 200);
    // }
    // else {
    //   this.instrusctionsBeforeTest = true;
    //   this.getuserdasstest();
    // }

    //this.getuserdasstest();
  }

  InstructionbeforetestModalClose() {
    this.InstructionbeforetestModal.hide()
    // if (this.dataManipSrvc.testType == "optionstest") {
    if (!this.instrusctionsBeforeTest) {
      this.getusertest();
    }
    this.instrusctionsBeforeTest = true;
    //  }
    //  else if (this.dataManipSrvc.testType == "colortest") {

    //  }


  }

  openTrailTestModal() {
    const ngbModalRef = this.ngbModal.open(TrailTestModalComponent, { windowClass: "trail-est-demo-modal", backdrop: 'static' });
    ngbModalRef.componentInstance.trialTestObj = this.trialTestObj;

    ngbModalRef.result.then((result) => {
      //      console.log("result", result);

      if (result && result?.status == "finish") {
        this.finishTrailTest(result?.data)
      }
    });
  }

  nextquestionstatus() {
    this.dynamic += 1;
  }
  selectColorEvt(i) {
    this.colorClickCount++;
    this.colorArray[i]["display"] = false;
    let idx = this.colorArray.findIndex(ele => ele["display"] == true);
    if (this.colorClickCount == this.colorArray.length - 1) {
      this.tempSelctedColors += this.colorArray[i]["value"];
    }
    else {
      this.tempSelctedColors += this.colorArray[i]["value"] + ",";

    }
    if (idx == -1) {
      this.colorsAttempt++;
      this.selectedColors.push({ "clickorder": this.tempSelctedColors });
      if (this.colorsAttempt == 2) {
        // this.showSubmitColor = true;
        this.SubmitColorEvt();
      }
      else {
        this.tempSelctedColors = "";
        this.colorTestInstructions = [];
        this.colorTestInstructions.push({
          "instrhead": "",
          "instr": this.dataManipSrvc.testInstructions["duringtestinstr"]["betweenrounds"]["instr" + this.testLang]
        })
        this.showNextColors = true;
      }
    }
  }
  NextColorEvt() {
    this.shuffle(this.tempColorArray);
    this.colorTestInstructions = [];
    this.colorTestInstructions.push({
      "instrhead": this.dataManipSrvc.testInstructions["duringtestinstr"]["round2"]["roundheading" + this.testLang],
      "instr": this.dataManipSrvc.testInstructions["duringtestinstr"]["round2"]["roundinstr" + this.testLang]
    })
    this.colorClickCount = -1;
    this.colorArray = [];
    this.colorArray = this.tempColorArray.map(x => Object.assign({}, x));
    this.showNextColors = false;
    this.colorInstructionLabel = "Instructions Iteration 2";
    this.colorIteraionFirst = false;
    this.dynamic++;
  }
  SubmitColorEvt() {
    let colorAnswerObj = {};
    this.testPaperList = [];
    for (let i = 0; i < this.selectedColors.length; i++) {
      colorAnswerObj = {
        "answer": '',
        "isattempted": 'Y',
        "timespend": 0,
        "answerstatus": ""
      }
      colorAnswerObj["answer"] = this.selectedColors[i]["clickorder"];
      this.testPaperList.push({ "useranswer": colorAnswerObj });
    }
    // let obj = {};
    // obj["userid"] = this.dataManipSrvc.userId;
    // obj["testid"] = this.dataManipSrvc.testId;
    // obj["usertestid"] = this.dataManipSrvc.usertestid;
    // obj["testremainingtime"] = 100;//this.testTimer["testTimeRemaining"] ? +this.testTimer["testTimeRemaining"] : 0;
    // obj["testpaper"] = this.testPaperList;
    // console.log("Color JSON:", JSON.stringify(obj));
    //this.router.navigateByUrl("/dashboard");
    this.finishTest();
  }
  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }



  getusertest() {
    this.showLoader = true;

    let body = {
      "tdiu": this.encryptService.encrypt(this.dataManipSrvc.usertestid + ""),
      "tdi": this.encryptService.encrypt(this.dataManipSrvc.testId + ""),
      "sl": this.encryptService.encrypt(this.testLang)
    }
    console.log(this.dataManipSrvc.usertestid, this.dataManipSrvc.testId, this.testLang);

    let apiUrl = this.configSetting.getBaseUrl() + "user/getuserdasstest";
    this.commonServices.postMethod(apiUrl, body).subscribe(respTestPaper => {
      this.showLoader = false;

      // console.log("User Tests.....", JSON.stringify(successResp));
      if (respTestPaper["errorCode"] == "000000") {
        this.currentQuesData = {};
        this.showloader = false;
        if (this.dataManipSrvc.testType == 'trailtest') {
          // console.log(respTestPaper);
          this.trialTestObj = respTestPaper['Data'];
          this.openTrailTestModal()

          return;
        }
        if (this.dataManipSrvc.testType == 'successtest') {
          const data = JSON.stringify(respTestPaper['Data']);
          this.router.navigate(['/image-selection'], { queryParams: { data: data }, skipLocationChange: true, })
          return;
        }
        if (this.dataManipSrvc.testType == 'mindtendencytest') {
          const data = JSON.stringify(respTestPaper['Data']);
          this.router.navigate(['/mind-tendency-test'], { queryParams: { data: data }, skipLocationChange: true, })
          return;
        }
        if (this.dataManipSrvc.testType == "colortest") {

          this.colorTestInstructions.push({
            "instrhead": this.dataManipSrvc.testInstructions["duringtestinstr"]["round1"]["roundheading" + this.testLang],
            "instr": this.dataManipSrvc.testInstructions["duringtestinstr"]["round1"]["roundinstr" + this.testLang]
          })
          this.colorArray = respTestPaper["Data"]["testpattern"];
          this.tempColorArray = this.colorArray.map(x => Object.assign({}, x));
          this.shuffle(this.colorArray);
          return;
        }
        if (respTestPaper['Data'] != undefined) {
          this.testPaperList = JSON.parse(JSON.stringify(respTestPaper['Data']['testpattern']));
        }
        //For minimum questions
        // let tempArray = [];
        // for (let i = 0; i < this.testPaperList.length; i++) {
        //   tempArray.push(this.testPaperList[i]);
        //   if (i > 1) {
        //     break;
        //   }
        // }
        // this.testPaperList = [];
        // this.testPaperList = tempArray;
        //EndFor minimum questions
        this.currentQuesData = this.testPaperList[0];
        this.currentQuesData['disbleAnswerFields'] = false;// for timedout
        this.currentQuesData['showSubmitButton'] = true;
        this.currentQuesData['showResetButton'] = false;
        this.currentQuesData['quehasformula'] = "N";
        this.currentQuesData['hasimage'] = 'N';
        this.currentQuesData['opthasformula'] = "N";
        this.currentQuesData['optionhasimage'] = 'N';
        this.currentQuesData['answer'] = this.currentQuesData['useranswer']['answer'];
        if (this.currentQuesData["useranswer"]["isattempted"] == "Y") {
          this.currentQuesData["enableResetBtn"] = true;
        }

        this.showPrevQuesBtn = true;
        this.showNextQuesBtn = true;
        this.displayActionButtons = true;
        this.quesStatusCount = {
          "totalQueCount": 0,
          "corrAnsCount": 1,
          "wroAnsCount": 0,
          "attQueCount": -1,
          "notAttQueCount": 0,
          "timeOutQueCount": 0,
          "skipQueCount": 0,
          // "remainingQuesCount": 0
        };
        this.testConfigObj["isquestionmadatory"] = "Y";
        this.testConfigObj["displayTimedOutMsg"] = "N";
        this.testConfigObj['isgoingbackallow'] = 'Y';
        this.testConfigObj['isskipallow'] == 'N';
        this.testConfigObj['totalquestions'] = this.testPaperList.length;
        this.quesStatusCount['totalQueCount'] = this.testConfigObj['totalquestions'];
        this.testConfigObj['isquestiontimed'] = 'N';
        this.getQuesData(this.currentQuesData);
      }
      else {
        this.showloader = false;
        this.showMandatoryMdlObj.msg = "Something went wrong. Please contact admin"// this.messsages["EXCPT"];//this.messsages["EXCPT"];//Something went wrong. Please contact to admin.";
        this.showMandatoryMdlObj.show = true;
      }
    },
      respTestPaperFailure => {
        this.showloader = false;
        this.showMandatoryMdlObj.msg = "Something went wrong. Please contact admin"// this.messsages["EXCPT"];//this.messsages["EXCPT"];//Something went wrong. Please contact to admin.";
        this.showMandatoryMdlObj.show = true;
      }
    )
  }

  setLanguageEvt() {
    this.languageConfirmModal.hide();
    this.beforeSelctedLang = this.prefLang;
    this.checkLanguage = false;
    this.changeLangugae(this.prefLang);
  }
  languageConfirmModalCloseEvt() {
    this.languageConfirmModal.hide();
    this.checkLanguage = false;
    if (this.beforeSelctedLang != '') {
      this.prefLang = this.beforeSelctedLang;
      this.testLang = this.beforeSelctedLang;
      this.getQuesData(this.currentQuesData);
    }
  }

  changeLangugae(value) {
    this.testLang = value;

    this.getQuesData(this.currentQuesData);
  }
  getQuesData(ReqQuesAndAnswerObj: any) {

    // try {
    this.currentQuesData = {};
    this.currentQuesData = ReqQuesAndAnswerObj;
    this.quesStatusCount['attQueCount'] = +this.quesStatusCount['attQueCount'] + 1;
    if (this.testConfigObj["testTimeOut"]) { return; }
    this.showloader = true;
    this.displayTimedOutMsg = false;
    this.showQuesStatus = false;

    // let paramObj = {};
    let srNo = ReqQuesAndAnswerObj["srno"] ? ReqQuesAndAnswerObj["srno"] : ReqQuesAndAnswerObj["srNo"];




    // clear interval here
    if (this.quesIntervalValue) {
      clearInterval(this.quesIntervalValue);
      clearInterval(this.quesIntervalValue);
    }

    this.quesTimeRemainig.consumedTime = 0;
    this.quesTimeRemainig.quesTotTime = 0;

    this.quesTimeRemainig.minute = "00";
    this.quesTimeRemainig.seconds = "00";
    this.submitBtnText = "Submit and Next";


    if (srNo == this.testPaperList.length) {
      this.showFinishTestBtn = true;
      this.currentQuesData['showSubmitButton'] = false;
    }
    else {
      this.submitBtnText = "Submit and Next";
      this.showFinishTestBtn = false;
      this.currentQuesData['showSubmitButton'] = true;
    }


    if (this.currentQuesData["questiontype"] == "OT") {
      ReqQuesAndAnswerObj["useranswer"]["useruploadimg"] = this.currentQuesData["imageName"]
    }
    ReqQuesAndAnswerObj['usertestpaperno'] = +this.UserObj["usertestpaperno"];
    ReqQuesAndAnswerObj["testremainingtime"] = +this.testTimer["testTimeRemaining"];

    if (this.previousAnswerObj) {
      if (this.previousAnswerObj["isattempted"] == "N" && ReqQuesAndAnswerObj["useranswer"]["isattempted"] == "Y") {
        this.quesStatusCount["attQueCount"]++;
        this.quesStatusCount["notAttQueCount"]--;
      }
      if (this.previousAnswerObj["isattempted"] == "S" && ReqQuesAndAnswerObj["useranswer"]["isattempted"] == "Y") {
        this.quesStatusCount["skipQueCount"]--;
        this.quesStatusCount["attQueCount"]++;
        this.quesStatusCount["notAttQueCount"] = this.testConfigObj["totalquestions"] - this.quesStatusCount["attQueCount"];
      }
      if (this.previousAnswerObj["isattempted"] == "S" && ReqQuesAndAnswerObj["useranswer"]["isattempted"] == "N") {
        this.quesStatusCount["skipQueCount"]--;
      }
      if (this.previousAnswerObj["isattempted"] == "Y" && ReqQuesAndAnswerObj["useranswer"]["isattempted"] == "N") {
        this.quesStatusCount["notAttQueCount"]++;
        this.quesStatusCount["attQueCount"]--;

      }
    }


    if (ReqQuesAndAnswerObj["useranswer"] && ReqQuesAndAnswerObj["useranswer"]["isattempted"] == "Y") {
      this.displayQuesSuccMsg = true;
    }
    else {
      this.displayQuesSuccMsg = false;
    }
    // if ()

    // reset values for quesTimeRemainig object to set timer with ProgBar width
    this.quesTimeSpentPer = 0;
    this.quesTimeSpent = 0;
    this.quesTimeRemainig.quesTotTime = 0;
    this.quesTimeRemainig.consumedTime = 0;
    this.quesTimeRemainig.quesTotTime = 0;
    this.quesTimeRemainig.PBwidth = {};
    // end of reset time quesTimeRemainig obj.

    this.displayTimedOutMsg = false; //this.displayQuesSuccMsg = false;

    // this.currentQuesData["showSubmitButton"] = true;
    this.currentQuesData["enableResetBtn"] = false;
    if (this.testConfigObj["isresetanswerallow"] == "Y") {
      this.currentQuesData["showResetButton"] = true;
    }
    this.currentQuesData["instructiontext"] = (this.currentQuesData["instructiontext"] == null) ? "" : this.currentQuesData["instructiontext"]

    if (this.currentQuesData["questiontype"] == "MF" || this.currentQuesData["questiontype"] == "MM") {

      var outputJson = {};
      outputJson = this.processingOnMFandMMQuestion(this.currentQuesData)
      this.currentQuesData = JSON.parse(JSON.stringify(outputJson));
    }

    /// This block will update the JSON of "Comprehensive Type"(CT) type of question because here Questions are available in the "options" array.
    else if (this.currentQuesData["questiontype"] == "CT") {


      /// Question wise JSON updation ///
      for (let quesIndex = 0; quesIndex < this.currentQuesData["options"].length; quesIndex++) {
        // 
        var questionObj = this.currentQuesData["options"][quesIndex];
        // if (questionObj["instructiontext"] != undefined && questionObj["instructiontext"] != null && questionObj["instructiontext"] != "") {
        //     questionObj["qtext"] = questionObj["instructiontext"] + "<br>" + questionObj["qtext"];
        // }
        for (let i = 0; i < this.currentQuesData["useranswer"]["usersubqueanswer"].length; i++) {
          if (questionObj["qno"] == this.currentQuesData["useranswer"]["usersubqueanswer"][i]["qno"]) {
            questionObj["useranswer"] = this.currentQuesData["useranswer"]["usersubqueanswer"][i] ? this.currentQuesData["useranswer"]["usersubqueanswer"][i] : {};
            break;
          }
        }

        // for new
        let imagepath: string = questionObj["imagepath"];
        // questionObj["qtext"] = "hi";

        if (imagepath.trim().length && imagepath.indexOf("data") == -1) {
          questionObj["imagepath"] = "";
          questionObj["imagepath"] = "data:image/png;base64," + imagepath;
        }

        if (questionObj["optionhasimage"] == "Y") {
          let optimage: string = "";
          for (let index = 0; index < questionObj["options"].length; index++) {
            const element = questionObj["options"][index];
            optimage = questionObj["options"][index]["optimage"];

            if (optimage.trim().length && optimage.indexOf("data") == -1) {
              questionObj["options"][index]["optimage"] = "data:image/png;base64," + optimage;
            }
            questionObj["options"][index]["opttext"].replace(/\n/g, "<br>")
          }

        }

        if (questionObj["qtype"] == "FG") {/// If question type is Filling the gap then processig on input JSON is required to show the input textbox in that question.
          var UpdatedObj = {};
          questionObj['QtextResetAnswer'] = JSON.parse(JSON.stringify(questionObj['qtext']));
          UpdatedObj = this.processingOnFGQuestion(questionObj);
          questionObj = JSON.parse(JSON.stringify(UpdatedObj));
          // console.log("questionObj : ", JSON.stringify(questionObj));
        }
        else if (questionObj["qtype"] == "MF" || questionObj["qtype"] == "MM") {
          var outputedJson = {};
          outputedJson = this.processingOnMFandMMQuestion(questionObj)
          questionObj = JSON.parse(JSON.stringify(outputedJson));
        }
        else if (questionObj["qtype"] == "MC") {

          var answer: any;
          answer = questionObj["useranswer"]["answer"] ? questionObj["useranswer"]["answer"] : "";

          if (answer) {
            answer.split(/,/gmi);
            for (let i = 0; i < answer.length; i++) {
              for (let j = 0; j < questionObj["options"].length; j++) {
                if (answer[i] == questionObj["options"][j]["optvalue"]) {
                  questionObj["options"][j]["ischecked"] = true;
                  // break;
                }
              }
            }
          }

        }
        else if (questionObj["qtype"] == "AR" || questionObj["qtype"] == "TF" || questionObj["qtype"] == "SC" || questionObj["qtype"] == "OT" || questionObj["qtype"] == "ST" || questionObj["qtype"] == "MT") {
          if (questionObj["qtype"] == "OT") {
            questionObj['UserImage'] = "";
            questionObj["imageName"] = "";
            questionObj['UserImage'] = questionObj['useranswer']['useruploadimg'] ? questionObj['useranswer']['useruploadimg'] : "";
            questionObj["imageName"] = questionObj['useranswer']['useruploadimg'] ? questionObj['useranswer']['useruploadimg'] : "";
          }
          this.selectedUserImage = null;
          questionObj["answer"] = questionObj["useranswer"]["answer"] ? questionObj["useranswer"]["answer"] : "";
        }
        else if (questionObj["qtype"] == "NT") {
          questionObj["answer"] = "";
          questionObj["answer"] = questionObj["useranswer"]["answer"] ? parseInt(questionObj["useranswer"]["answer"]) : questionObj["useranswer"]["answer"];
        }

        this.currentQuesData["options"][quesIndex] = JSON.parse(JSON.stringify(questionObj));
      }


      ///End question wise JSON updation
    }///End CT type question block

    if (this.currentQuesData["questiontype"] == "OT") {
      this.currentQuesData['UserImage'] = "";
      this.currentQuesData["imageName"] = "";
      this.currentQuesData['UserImage'] = this.currentQuesData['useranswer']['useruploadimg'] ? this.currentQuesData['useranswer']['useruploadimg'] : "";
      this.currentQuesData["imageName"] = this.currentQuesData['useranswer']['useruploadimg'] ? this.currentQuesData['useranswer']['useruploadimg'] : "";
      if (this.currentQuesData["useranswer"]["answer"] || this.currentQuesData["imageName"]) {
        this.currentQuesData["enableSubmitButton"] = true;
      }
    }

    this.currentQuesData["answer"] = this.currentQuesData["useranswer"]["answer"];



    if (this.currentQuesData["questiontype"] == "NT" || this.currentQuesData["questiontype"] == "ST") {
      this.currentQuesData["answer"] = "";

      // this.currentQuesData["answer"] +=this.currentQuesData["useranswer"]["answer"];
      if (this.currentQuesData["questiontype"] == "NT") {
        this.currentQuesData["answer"] = this.currentQuesData["useranswer"]["answer"] ? parseInt(this.currentQuesData["useranswer"]["answer"]) : this.currentQuesData["useranswer"]["answer"];
      }
      else {
        this.currentQuesData["answer"] = this.currentQuesData["useranswer"]["answer"] ? this.currentQuesData["useranswer"]["answer"] : "";
      }

      if (this.currentQuesData["useranswer"]["answer"]) {
        this.currentQuesData["enableSubmitButton"] = true;
      }
    }

    if (this.currentQuesData["useranswer"]) {
      this.previousAnswerObj = {};
      this.previousAnswerForCT = {};
      if (this.currentQuesData["questiontype"] == "CT") {
        this.previousAnswerForCT = (this.currentQuesData["questiontype"] == "CT") ? JSON.parse(JSON.stringify(this.currentQuesData["useranswer"]["usersubqueanswer"])) : JSON.parse(JSON.stringify(this.currentQuesData["useranswer"]));
      }
      this.previousAnswerObj = JSON.parse(JSON.stringify(this.currentQuesData["useranswer"]));
    }
    this.length = 0;

    if (this.currentQuesData["timeremaining"] <= 0) {
      this.currentQuesData["timeremaining"] = 0;
      // this.quesTimeRemainig.PBwidth["width"] = "0%";
      /// timeout scenario
      // 
      // if (this.testConfigObj["isquestiontimed"] == "Y") {
      //   this.setVariableForTimeout(true);
      // }
      // else {
      //   this.setVariableForTimeout(false);
      // }
    }

    else {
      // this.setVariableForTimeout(false);
    }
    if (this.currentQuesData["quehasformula"] == "N") {
      if (!this.currentQuesData["qtext" + this.testLang]) {
        let idx = this.languages.findIndex(ele => ele["value"] == this.testLang);
        if (idx >= 0) this.languages[idx]["display"] = false;
        this.languageConfirmModal.show();
        return;
      }
      this.currentQuesData["qtext"] = this.currentQuesData["qtext" + this.testLang].replace(/\n/g, "<br>");
      if (this.currentQuesData['questiontype'] == 'MT') {
        this.currentQuesData["subqtext"] = this.currentQuesData["subqtext" + this.testLang].replace(/\n/g, "<br>");
      }
    }
    this.currentQuesData["srno"] = ReqQuesAndAnswerObj["srno"];

    if (this.currentQuesData["questiontype"] == "FG") {
      var UpdatedObj = {};
      this.currentQuesData['QtextResetAnswer'] = JSON.parse(JSON.stringify(this.currentQuesData['qtext']));
      UpdatedObj = this.processingOnFGQuestion(this.currentQuesData);
      this.currentQuesData = JSON.parse(JSON.stringify(UpdatedObj));
    }
    else {
      for (let index = 0; index < this.currentQuesData["options"].length; index++) {
        const element = this.currentQuesData["options"][index];
        if (this.currentQuesData["answer"].indexOf(element["optvalue"]) != -1) {
          this.currentQuesData["options"][index]["ischecked"] = true;
          if (this.currentQuesData["questiontype"] == "MC") {
            this.checkboxChange(true, this.currentQuesData["options"][index]);
          }
        }
      }
    }
    // }

    if (this.currentQuesData["opthasformula"] == "N" && this.currentQuesData["questiontype"] != "CT") {
      for (let index = 0; index < this.currentQuesData["options"].length; index++) {
        // const element = this.currentQuesData["options"][index];
        this.currentQuesData["options"][index]["opttext"] = this.currentQuesData["options"][index]["opttext" + this.testLang].replace(/\n/g, "<br>")
      }
    }

    this.displayActionButtons = true;

    if (this.testConfigObj["isquestiontimed"] && this.testConfigObj["isquestiontimed"] == "Y") {
      this.quesTimeRemainig.PBwidth["width"] = "0%";

      if (this.currentQuesData["timeremaining"] == "000000") {
        return;
      }

      this.quesTimeRemainig.quesTotTime = this.currentQuesData["timeremaining"] + this.currentQuesData["useranswer"]["timespend"];
      this.quesTimeSpent = this.currentQuesData["useranswer"]["timespend"];
      this.quesTimeSpentPer = Math.floor((this.quesTimeSpent / this.quesTimeRemainig.quesTotTime) * 100);
      let width = (100 - this.quesTimeSpentPer).toString();
      this.quesTimeRemainig.PBwidth["width"] = width + "%";
      // console.log("quesquesTotTime :  ", this.quesTimeRemainig.quesTotTime);

      // this.setQuesTimer();

      // this.quesIntervalValue = setInterval(() => {
      //     this.currentQuesData["timeremaining"] -= 1;
      //     this.quesTimeRemainig.consumedTime += 1;
      //     this.setQuesTimer();
      // }, 1000)
    }
    else {
      this.displayTimedOutMsg = false;
      clearInterval(this.quesIntervalValue);
      clearInterval(this.quesIntervalValue);
    }

    this.displayActionButtons = false;
    this.showloader = false;
  }

  submitAnswer() {
    try {
      /***
       * If user clicked on submit answer without select an option(s) then display the message.
       ***/
      this.modalImage = "";
      this.showQuesStatus = false;
      /********
          * If 
          *  question is mandatory then assign the selected answers to the answer key of currentQuesData i.e currentQuesData["answer"];
          * ELSE
          *  set answer value as empty string which will be handle by the below code.
          * 
          */
      // prepare 
      //  document.getElementById("closebtn").click();

      if (this.currentQuesData["questiontype"] == "CT") {
        var returnedObj = {};
        var isCTTypeValid = false;
        //returnedObj = this.prepareCTanswer(this.currentQuesData);
        this.currentQuesData = JSON.parse(JSON.stringify(returnedObj))
      }
      else if (this.currentQuesData["questiontype"] == "MC" || this.currentQuesData["questiontype"] == "MM" || this.currentQuesData["questiontype"] == "MF" || this.currentQuesData["questiontype"] == "FG") {
        var QueObj = {};
        // QueObj = this.prepareMC_MF_MM_FG_Answer(this.currentQuesData["questiontype"], this.currentQuesData);
        this.currentQuesData = JSON.parse(JSON.stringify(QueObj));
      }
      else if (this.currentQuesData['questiontype'] == "OT") {
        if (this.currentQuesData["imageName"] != "" && this.currentQuesData["answer"] == "") {
          this.currentQuesData["answer"] = "AnswerImageSelectedMassage";

        }
      }
      if (this.testConfigObj["isquestionmadatory"] == "Y") {
        if ((this.currentQuesData["answer"] == undefined || this.currentQuesData["answer"] == null || this.currentQuesData["answer"] == "")
          || (this.currentQuesData["questiontype"] == "FG" && this.currentQuesData["isTextAvailable"] == false) || ((this.currentQuesData["questiontype"] == "MF" || this.currentQuesData["questiontype"] == "MM") && this.currentQuesData["isTextAvailable"] == false)) {
          this.modalCondition = "";
          this.showMandatoryMdlObj.msg = this.messsages["QP001"]; //All questions are mandatory, please select the answer.;
          this.showMandatoryMdlObj.show = true;
          return false;
        }
      }
      else if (this.testConfigObj["isquestionmadatory"] == "N") {
        if ((this.currentQuesData["answer"] == undefined || this.currentQuesData["answer"] == null || this.currentQuesData["answer"] == "") ||
          (this.currentQuesData["questiontype"] == "FG" && this.currentQuesData["isTextAvailable"] == false) || ((this.currentQuesData["questiontype"] == "MF" || this.currentQuesData["questiontype"] == "MM") && this.currentQuesData["isTextAvailable"] == false)) {
          this.modalCondition = "";
          this.showMandatoryMdlObj.msg = this.messsages["QP002"]; //"Please select the answer."
          this.showMandatoryMdlObj.show = true;
          return false;
        }
      }

      if (this.currentQuesData["questiontype"] == "CT" && this.currentQuesData["answer"] == "UserAttemptThisQues") {
        this.currentQuesData["answer"] = "";
      }
      if (this.currentQuesData["answer"] == "AnswerImageSelectedMassage") {
        this.currentQuesData["answer"] = "";
        this.currentQuesData["useranswer"]["answer"] = "";
      }
      let ReqQuesAndAswerObj = this.prepareUserAnswerObject();
      // ReqQuesAndAswerObj.srno = +this.currentQuesData["srno"] + 1;
      this.clickedFrom = "NextBtn";


      var question = {};
      for (let i = 0; i < this.testPaperList.length; i++) {
        const element = this.testPaperList[i];
        if (ReqQuesAndAswerObj['questionid'] == element['questionid']) {
          // if(this.testPaperList[i+1] )
          question = this.testPaperList[i + 1];
          break;
        }

      }
      if (question != undefined) {
        question['disbleAnswerFields'] = false;// for timedout
        // question['showSubmitButton'] = true;
        question['showResetButton'] = false;
        question['quehasformula'] = "N";
        question['hasimage'] = 'N';
        question['opthasformula'] = "N";
        question['optionhasimage'] = 'N';
        question['answer'] = question['useranswer']['answer'];
        if (question["useranswer"]["isattempted"] == "Y") {
          question["enableResetBtn"] = true;
        }

        this.showPrevQuesBtn = true;
        this.showNextQuesBtn = true;
        this.displayActionButtons = true;

        this.getQuesData(question); if (question['useranswer']['answer'] != '') {
          this.displayQuesSuccMsg = true;
        }
      }
      else {
        this.currentQuesData['showSubmitButton'] = false;
        this.quesStatusCount.attQueCount = +this.quesStatusCount.attQueCount + 1;
      }
      // this.nextQuestion();
      /// submit 
      this.dynamic += 1;
    }
    catch (exc) {
      // console.log("exception  : ", exc);
    }
  }

  prepareUserAnswerObject(isSkipQuestion: boolean = false, isTimeout: boolean = false) {

    var ReqQuesAndAswerObj = {
      // "marks": 0,

      "srno": this.currentQuesData['srno'],
      "totaltime": this.currentQuesData['totaltime'],
      "questionid": this.currentQuesData['questionid'],
      "qtext": this.currentQuesData['qtext'],//+this.dataManipSrvc.prefLanguage
      "quesubscale": this.currentQuesData['quesubscale'],
      "questiontype": this.currentQuesData['questiontype'],
      "options": this.currentQuesData['options'] ? this.currentQuesData['options'] : [],
      "useranswer": {
        // "ansquestionsrno": this.currentQuesData["srno"],
        // "ansquestionid": this.currentQuesData["questionid"],
        "answer": this.currentQuesData["answer"] ? this.currentQuesData["answer"].toString() : "",
        "isattempted": "Y",
        "timespend": this.quesTimeRemainig.consumedTime,
        "answerstatus": "",
        // "isanscasesensitive": this.currentQuesData["isanscasesensitive"],
        // "useruploadimg": this.currentQuesData["useruploadimg"]
        // "usersubqueanswer": []
      }
    };

    if (this.currentQuesData["answer"] == "AnswerImageSelectedMassage") {
      this.currentQuesData["answer"] = "";
      this.currentQuesData["useranswer"]["answer"] = "";
    }
    if (this.currentQuesData["questiontype"] == "CT") {
      // this.currentQuesData["useranswer"]["usersubqueanswer"] = [];
      ReqQuesAndAswerObj["useranswer"]["usersubqueanswer"] = [];
      // this.currentQuesData["useranswer"]["usersubqueanswer"] = this.currentQuesData["CTSubQuesAnswers"];
      ReqQuesAndAswerObj["useranswer"]["usersubqueanswer"] = this.currentQuesData["CTSubQuesAnswers"];
      // delete this.currentQuesData["CTSubQuesAnswers"];
    }

    if (this.currentQuesData["questiontype"] == "MT") {
      ReqQuesAndAswerObj["subqtext"] = this.currentQuesData["subqtext"];
      ReqQuesAndAswerObj["useranswer"]["subqanswer"] = this.currentQuesData["useranswer"]["subqanswer"];
    }
    if (isSkipQuestion) {
      if (this.currentQuesData["questiontype"] == "CT") {
        for (let j = 0; j < ReqQuesAndAswerObj["useranswer"]["usersubqueanswer"].length; j++) {
          // this.currentQuesData["useranswer"]["usersubqueanswer"][j]["answer"] = "";
          // this.currentQuesData["useranswer"]["usersubqueanswer"][j]["isattempted"] = "N";
          ReqQuesAndAswerObj["useranswer"]["usersubqueanswer"][j]["answer"] = "";
          ReqQuesAndAswerObj["useranswer"]["usersubqueanswer"][j]["isattempted"] = "N";
        }
        this.currentQuesData["useranswer"] = ReqQuesAndAswerObj["useranswer"]
      }
      else {
        ReqQuesAndAswerObj["useranswer"].answer = "";
      }
      ReqQuesAndAswerObj["useranswer"].isattempted = "S";
    }
    else if (isTimeout) {
      ReqQuesAndAswerObj["useranswer"].answer = "";
      ReqQuesAndAswerObj["useranswer"].isattempted = "T";
      if (this.previousAnswerObj["isattempted"] != "Y") {
        this.currentQuesData["useranswer"] = ReqQuesAndAswerObj["useranswer"];
      }
    }
    //if we says next after timeout reqQuesAndAnswerObj.useranswer must contain isattempted = "T"
    else if (this.currentQuesData["istimedout"] == true) {
      ReqQuesAndAswerObj["useranswer"].answer = "";
      ReqQuesAndAswerObj["useranswer"].isattempted = "T";
      if (this.previousAnswerObj["isattempted"] != "Y") {
        this.currentQuesData["useranswer"] = ReqQuesAndAswerObj["useranswer"];
      }
    }


    for (let i = 0; i < this.testPaperList.length; i++) {
      const element = this.testPaperList[i];
      if (element['srno'] == ReqQuesAndAswerObj['srno']) {
        this.testPaperList[i] = (JSON.parse(JSON.stringify(ReqQuesAndAswerObj)));
        break;
      }
    }
    return ReqQuesAndAswerObj;
  }

  processingOnMFandMMQuestion(inputJson) {

    var InputJsonObj = JSON.parse(JSON.stringify(inputJson));
    InputJsonObj["leftsideoptions"] = InputJsonObj["options"]["leftside"];
    InputJsonObj["rightsideoptions"] = InputJsonObj["options"]["rightside"];

    InputJsonObj["answerList"] = [];
    for (let i = 0; i < InputJsonObj["rightsideoptions"].length; i++) {
      let obj = {};
      obj['value'] = InputJsonObj["rightsideoptions"][i]['optvalue'];
      obj['display'] = InputJsonObj["rightsideoptions"][i]['optvalue'];
      InputJsonObj["answerList"].push(obj);
    }
    // InputJsonObj["options"]["leftside"][0]["opttext"]="This ia sample text.....................sdfsdfssdgsdgThis ia sample text.....................sdfsdfssdgsdg ,This ia sample text.....................sdfsdfssdgsdg";
    // InputJsonObj["options"]["rightside"][0]["opttext"]="This ia sample text.....................sdfsdfssdgsdg,This ia sample text.....................sdfsdfssdgsdg";

    InputJsonObj["changedtxt"] = {};
    InputJsonObj["enableSubmitButton"] = false;
    if (InputJsonObj["useranswer"] && InputJsonObj["useranswer"]["isattempted"] == "Y") {
      var answers = InputJsonObj["useranswer"]["answer"].split(/,/gmi);
    }
    let answercount = 0; let i = 0;
    for (let index = 0; index < InputJsonObj["leftsideoptions"].length; index++) {
      var JSONKey = "ansmf" + index.toString();
      // if answer is already saved then get populated here
      if (InputJsonObj["useranswer"] && InputJsonObj["useranswer"]["isattempted"] == "Y") {
        for (i; i < answers.length;) {
          InputJsonObj["enableSubmitButton"] = true;
          InputJsonObj[JSONKey] = answers[i];
          // InputJsonObj["enableSubmitButton"] = true;
          i++;// answercount += 1;
          break;
        }
      }
      else {
        InputJsonObj[JSONKey] = "";
      }
      answercount += 1;
    }
    InputJsonObj["answercount"] = answercount;
    // InputJsonObj["requiredCount"] = InputJsonObj["leftsideoptions"].length;

    if (this.testConfigObj["isquestionmadatory"] == "Y") {
      InputJsonObj["requiredCount"] = InputJsonObj["leftsideoptions"].length;
    }
    InputJsonObj["Allowedrows"] = [];
    for (let index = 0; index < InputJsonObj["noofchoice"]; index++) {
      // const element = array[index];
      InputJsonObj["Allowedrows"].push({});
    }
    return InputJsonObj;
  }

  processingOnFGQuestion(inputObject): any {

    var UpdatedJSONObj = {};
    UpdatedJSONObj = JSON.parse(JSON.stringify(inputObject));
    let quesString: string = "";
    // while clearing the answer we need to make textboxes empty 
    if (typeof UpdatedJSONObj["qtext"] != "string") {
      UpdatedJSONObj["qtext"] = (JSON.parse(JSON.stringify(UpdatedJSONObj['QtextResetAnswer'])))
    }
    quesString = UpdatedJSONObj["qtext"];
    // if CT type not have question has formula key
    if (UpdatedJSONObj['quehasformula'] && UpdatedJSONObj['quehasformula'] == 'Y') {
      quesString = quesString.replace(/\\\$[A-Za-z]{2}\\\$/gmi, " ### ");
    }
    else {
      quesString = quesString.replace(/\$[A-Za-z]{2}\$/gmi, " ### ");/// Replacing  $FG$ with ###, we are considering the pattern of $A-Za-z0-9$ without any hardcode 
    }
    quesString = quesString.replace(/\s+/gmi, " ");/// remove extra white spave in the string
    quesString = quesString.replace(/\s+$/gmi, "");/// remove last white space in string
    UpdatedJSONObj["selectedcount"] = 0;// 
    UpdatedJSONObj["enableSubmitButton"] = false;
    UpdatedJSONObj["requiredCount"] = 1;//select minimum 1 for 
    UpdatedJSONObj["qtext"] = quesString.split(/\s/gmi);
    UpdatedJSONObj["changedtxt"] = {};

    if (UpdatedJSONObj["useranswer"] && UpdatedJSONObj["useranswer"]["isattempted"] == "Y") {
      var answers = UpdatedJSONObj["useranswer"]["answer"].split(/,/gmi);
    }
    // let optionsKeys = Object.keys(UpdatedJSONObj["options"]);
    let answercount = 0; let i = 0;
    for (let index = 0; index < UpdatedJSONObj["qtext"].length; index++) {

      var qtext: string = UpdatedJSONObj["qtext"][index];
      if (qtext.indexOf("###") != -1) {
        var JSONKey = "ans" + answercount.toString();
        // if answer is already saved then get populated here
        if (UpdatedJSONObj["useranswer"] && UpdatedJSONObj["useranswer"]["isattempted"] == "Y") {
          for (i; i < answers.length;) {
            UpdatedJSONObj[JSONKey] = answers[i];
            UpdatedJSONObj["enableSubmitButton"] = true;
            i++;
            break;
          }
        }
        // else for new question (ans0,ans1....="") is placed in currentQuesData and qtext where ### occured.
        else {
          UpdatedJSONObj[JSONKey] = "";
        }
        UpdatedJSONObj["qtext"][index] = JSONKey;
        answercount += 1;
      }
    }
    UpdatedJSONObj["answercount"] = answercount;
    if (this.testConfigObj["isquestionmadatory"] == "Y") {
      UpdatedJSONObj["requiredCount"] = UpdatedJSONObj["qtext"].length.length;
    }

    return UpdatedJSONObj;
  }

  checkboxChange(ischeckedflag, option) {
    let isChecked = ischeckedflag;
    if (!this.currentQuesData["answer"]) {
      this.currentQuesData["answer"] = "";
    }

    if (this.currentQuesData["checkedcount"] == undefined) {
      this.currentQuesData["checkedcount"] = 0;
    }

    if (isChecked) {
      this.currentQuesData["checkedcount"] += 1;
    }
    else {
      this.currentQuesData["checkedcount"] -= 1;
    }
  }

  confirmFinishTest() {
    let ReqQuesAndAswerObj = this.prepareUserAnswerObject();
    if (this.testConfigObj["isquestionmadatory"] == "Y") {
      this.quesStatusCount = {
        "totalQueCount": this.testPaperList.length,
        "corrAnsCount": 0,
        "wroAnsCount": 0,
        "attQueCount": 0,
        "notAttQueCount": 0,
        "timeOutQueCount": 0,
        "skipQueCount": 0,
        // "remainingQuesCount": 0
      }; for (let i = 0; i < this.testPaperList.length; i++) {
        const element = this.testPaperList[i];
        switch (element["useranswer"]["isattempted"].trim()) {
          case "W":
            this.quesStatusCount["wroAnsCount"]++;
            this.quesStatusCount["attQueCount"]++;
            break;
          case "R":
            this.quesStatusCount["corrAnsCount"]++;
            this.quesStatusCount["attQueCount"]++;
            break;
          case "Y":
            this.quesStatusCount["attQueCount"]++;
            break;
          case "N":
            this.quesStatusCount["notAttQueCount"]++;
            // this.quesStatusCount["remainingQuesCount"]++;
            break;
          case "S":
            this.quesStatusCount["skipQueCount"]++;
            this.quesStatusCount["notAttQueCount"]++;
            // this.quesStatusCount["remainingQuesCount"]++;
            break;
          case "T":
            this.quesStatusCount["timeOutQueCount"]++;
            this.quesStatusCount["notAttQueCount"]++;
            // this.quesStatusCount["remainingQuesCount"]++;
            break;
        }
      }
      let count = (this.quesStatusCount["attQueCount"] + this.quesStatusCount["timeOutQueCount"]);
      if (count < this.testConfigObj["totalquestions"]) {
        this.modalCondition = "";
        this.showMandatoryMdlObj.msg = this.messsages["QP001"]; //All questions are mandatory, please select the answer.;
        this.showMandatoryMdlObj.show = true;
        return;
      }
    }
    // else {/// if questions are not mandatory...
    this.modalCondition = "ConfirmFinishTest";
    // this.showAlerMdlObj.msg = this.messsages["QP006"]; //Do you want to finish the test ?;
    // this.showAlerMdlObj.noBtnText = "No";
    // this.showAlerMdlObj.yesBtnText = "Yes";
    // this.showAlerMdlObj.show = true;
    // }
    this.reviewTest();
    this.showFinishTestBtn = false;
  }

  yesOnAlert() {
    this.showAlerMdlObj.show = false;
    this.showAlerMdlObj.msg = "";
    if (this.modalCondition == "ConfirmFinishTest") {
      this.reviewTest();
      this.showFinishTestBtn = false;
    }
  }

  noOnAlert() {
    this.showAlerMdlObj.show = false;
    this.showAlerMdlObj.msg = "";
  }

  reviewTest() {
    this.reviewQueList = [];
    var list = JSON.parse(JSON.stringify(this.testPaperList));
    for (let i = 0; i < list.length; i++) {
      var question = list[i];

      if (question['correctansdiscimg'] != 'null' || question['correctansdisc'] != '' || question['correctansdiscimg'] != '') {
        question['showExplaination'] = "Y";
      }
      if (question['questiontype'] == 'FG') {
        var UpdatedObj = {};

        UpdatedObj = this.processingOnFGQuestion(question);

        question = JSON.parse(JSON.stringify(UpdatedObj));
      }
      if (question['questiontype'] == 'MF' || question['questiontype'] == "MM") {
        var outputJson = {};
        if (question['correctans']) {
          var ansArray = question['correctans'].split(/,/gmi);
          question['correctans'] = JSON.parse(JSON.stringify(ansArray));
        }
        else {
          question['correctans'] = [];
          let ans = "";
          for (let i = 0; i < question['options']['leftside'].length; i++) {
            question['correctans'].push(ans);
          }
        }
        outputJson = this.processingOnMFandMMQuestion(question)
        question = JSON.parse(JSON.stringify(outputJson));

      }
      /// This block will update the JSON of "Comprehensive Type"(CT) type of question because here Questions are available in the "options" array.
      else if (question['questiontype'] == 'CT') {

        /// Question wise JSON updation ///
        for (let quesIndex = 0; quesIndex < question['options'].length; quesIndex++) {
          // 
          var questionObj = question['options'][quesIndex];
          if (questionObj['instructiontext'] != undefined && questionObj['instructiontext'] != null && questionObj['instructiontext'] != '') {
            questionObj['qtext'] = questionObj['instructiontext'] + '<br>' + questionObj['qtext'];
          }
          for (let i = 0; i < question['useranswer']['usersubqueanswer'].length; i++) {
            if (questionObj['qno'] == question['useranswer']['usersubqueanswer'][i]['qno']) {
              questionObj['useranswer'] = question['useranswer']['usersubqueanswer'][i] ? question['useranswer']['usersubqueanswer'][i] : {};
              break;
            }
          }

          // for new
          let imagepath: string = questionObj['imagepath'];
          // questionObj['qtext'] = "hi";

          if (imagepath.trim().length && imagepath.indexOf("data") == -1) {
            questionObj['imagepath'] = "";
            questionObj['imagepath'] = 'data:image/png;base64,' + imagepath;
          }

          if (questionObj['optionhasimage'] == "Y") {
            let optimage: string = "";
            for (let index = 0; index < questionObj['options'].length; index++) {
              const element = questionObj['options'][index];
              optimage = questionObj['options'][index]['optimage'];
              if (optimage.trim().length && optimage.indexOf("data") == -1) {
                questionObj['options'][index]['optimage'] = 'data:image/png;base64,' + optimage;
              }
              questionObj['options'][index]['opttext'].replace(/\n/g, "<br>")
            }

          }
          if (questionObj['qtype'] == "FG") {/// If question type is Filling the gap then processig on input JSON is required to show the input textbox in that question.
            var UpdatedObj = {};
            UpdatedObj = this.processingOnFGQuestion(questionObj);
            questionObj = JSON.parse(JSON.stringify(UpdatedObj));
            // console.log("questionObj : ", JSON.stringify(questionObj));
          }
          else if (questionObj['qtype'] == 'MF' || questionObj['qtype'] == 'MM') {
            var outputedJson = {};
            if (questionObj['correctAns']) {
              var ansArray = questionObj['correctAns'].split(/,/gmi);
              questionObj['correctAns'] = JSON.parse(JSON.stringify(ansArray));
            }
            else {
              questionObj['correctAns'] = [];
              let ans = "";
              for (let i = 0; i < questionObj['options']['leftside'].length; i++) {
                questionObj['correctAns'].push(ans);
              }
            }
            outputedJson = this.processingOnMFandMMQuestion(questionObj)
            questionObj = JSON.parse(JSON.stringify(outputedJson));
          }
          else if (questionObj['qtype'] == 'MC') {
            var answer: any;
            answer = questionObj['useranswer']['answer'];
            if (answer) {
              answer.split(/,/gmi);
              for (let i = 0; i < answer.length; i++) {
                for (let j = 0; j < questionObj['options'].length; j++) {
                  if (answer[i] == questionObj['options'][j]['optvalue']) {
                    questionObj['options'][j]['ischecked'] = true;
                    // break;
                  }
                }
              }
            }
          }
          else if (questionObj['qtype'] == 'SC' || questionObj['qtype'] == 'OT' || questionObj['qtype'] == 'ST') {
            questionObj['answer'] = questionObj['useranswer']['answer'] ? questionObj['useranswer']['answer'] : "";
          }
          else if (questionObj['qtype'] == 'SC') {
            questionObj['useranswer']['subqanswer'] = questionObj['useranswer']['subqanswer']
          }
          else if (questionObj['qtype'] == 'NT') {
            questionObj['answer'] = "";
            questionObj['answer'] = questionObj['useranswer']['answer'] ? parseInt(questionObj['useranswer']['answer']) : questionObj['useranswer']['answer'];
          }

          question['options'][quesIndex] = JSON.parse(JSON.stringify(questionObj));
        }
        ///End question wise JSON updation
      }///End CT type question block

      let imagepath: string = question['imagepath'] ? question['imagepath'] : "";
      // question['qtext'] = "hi";

      if (imagepath.trim().length && imagepath.indexOf("data") == -1) {
        question['imagepath'] = "";
        question['imagepath'] = 'data:image/png;base64,' + imagepath;
      }
      let correctansdiscimg: string = question['correctansdiscimg'] ? question['correctansdiscimg'] : "";
      // question['qtext'] = "hi";

      if (correctansdiscimg.trim().length && correctansdiscimg.indexOf("data") == -1) {
        question['correctansdiscimg'] = "";
        question['correctansdiscimg'] = 'data:image/png;base64,' + correctansdiscimg;
      }
      if (question['optionhasimage'] == "Y") {
        if (question['questiontype'] != 'MF' && question['questiontype'] != "MM") {
          var options = question['options']
          for (let index = 0; index < options.length; index++) {
            const element = options[index];
            let optimage = options[index]['optimage'];
            if (optimage.trim().length && optimage.indexOf("data") == -1) {
              options[index]['optimage'] = 'data:image/png;base64,' + optimage;
            }
            options[index]['opttext'].replace(/\n/g, "<br>")
          }
        }
        else if (question['questiontype'] == 'MF' || question['questiontype'] == "MM") {
          var options = question['options']['leftside'];
          for (let index = 0; index < options.length; index++) {
            const element = options[index];
            let optimage = options[index]['optimage'];
            if (optimage.trim().length && optimage.indexOf("data") == -1) {
              options[index]['optimage'] = 'data:image/png;base64,' + optimage;
            }
            options[index]['opttext'].replace(/\n/g, "<br>")
          }
          var opt = question['options']['rightside'];
          for (let i = 0; i < opt.length; i++) {
            const element = opt[i];
            let optimage = opt[i]['optimage'];
            if (optimage.trim().length && optimage.indexOf("data") == -1) {
              opt[i]['optimage'] = 'data:image/png;base64,' + optimage;
            }
            opt[i]['opttext'].replace(/\n/g, "<br>")
          }

        }
      }
      question['disbleAnswerFields'] = false;// for timedout
      // question['showSubmitButton'] = true;
      question['showResetButton'] = false;
      question['quehasformula'] = "N";
      question['hasimage'] = 'N';
      question['opthasformula'] = "N";
      question['optionhasimage'] = 'N';
      question['answer'] = question['useranswer']['answer'];
      for (let j = 0; j < question['options'].length; j++) {
        const element = question['options'][j];
        if (question['answer'] == element['optvalue']) {
          element['checked'] = question['answer'];
        }

      }
      this.reviewQueList.push(question);
    }

    this.showloader = false;
    this.showQuestionsReview = true;
    this.testModal.show();
  }

  updateAnswer(event, mainquestion) {
    for (let i = 0; i < this.testPaperList.length; i++) {
      const element = this.testPaperList[i];
      if (mainquestion['questionid'] == element['questionid']) {
        // if(this.testPaperList[i+1] )
        // console.log("Before update", JSON.stringify(this.testPaperList[i]));
        this.testPaperList[i]['useranswer']['answer'] = mainquestion['answer'];
        // console.log("After update", JSON.stringify(this.testPaperList[i]));
        break;
      }

    }
  }

  finishTest() {
    this.testModal.hide();
    this.loaderText = "We are preparing the report";
    this.showloader = true;
    this.displayTimedOutMsg = false;
    this.displayActionButtons = false;
    // this.testConfigObj["testTimeOut"] = true;
    this.modalCondition = "";
    let apiUrl = this.configSetting.getBaseUrl() + "dashtest/finishdashtest";
    let obj = {};

    obj["testid"] = this.encryptService.encrypt(this.dataManipSrvc.testId + "");
    obj["usertestid"] = this.encryptService.encrypt(this.dataManipSrvc.usertestid + "");
    obj["testremainingtime"] = 100;//this.testTimer["testTimeRemaining"] ? +this.testTimer["testTimeRemaining"] : 0;
    obj["testpaper"] = this.testPaperList;
    this.commonServices.postMethod(apiUrl, obj)
      .subscribe(
        (quesData) => {
          this.showloader = false;
          if (quesData["errorCode"] == "000000" || quesData["errorCode"] == 888) {
            this.filePath = quesData["Data"]["resultpdf"];
            // extra condition to satisfy show review on okMandatory
            this.modalCondition = "testFinished";
            // this.testModal.hide();
            this.showQuestionsReview = false;
            //this.showMdlObj.msg = quesData["errorDescription"];
            this.showMdlObj.msg = "Test completed successfully. <br/>Click OK to see result !";

            if (quesData["errorCode"] == 888) {
              this.showMdlObj.emailerror = `Error while sending email`;
            }
            // if (this.dataManipSrvc.testId == 4) {
            //   this.showMdlObj.msg = "Test completed successfully. Preparing result please wait.";
            // }
            // else{
            //   this.showMdlObj.msg = "Test completed successfully. <br/>Check your mail to see result !";
            // }

            // this.showMdlObj.msg = "Saving your test and preparing your result. Please wait";
            this.showMdlObj.show = true;
          }
          else {
            this.showloader = false;
            console.error(" succ error ----------: " + quesData["errorDescription"]);
            this.showMandatoryMdlObj.msg = this.messsages["EXCPT"]//Something went wrong. Please contact to admin.";//
            this.showMandatoryMdlObj.show = true;
          }
        },
        err => {
          this.showloader = false;
          //// console.log("erro in get question : ", err);
          // console.error("err error----------: " + err["errorDescription"]);

          this.showMandatoryMdlObj.msg = this.messsages["EXCPT"]//Something went wrong. Please contact to admin.";//
          this.showMandatoryMdlObj.show = true;
        })

  }
  okMandatory() {
    this.showMandatoryMdlObj.show = false;
    this.showMandatoryMdlObj.msg = "";
  }

  answerEntered(event) {

    if (event) {
      if (typeof (event == "number")) {
        event = event.toString();
      }
      if (event.length > 0) {
        this.currentQuesData['enableSubmitButton'] = true;
      }
      else {
        if (this.currentQuesData["questiontype"] == "OT" && this.currentQuesData["useranswer"]["useruploadimg"] != "") {
          this.currentQuesData['enableSubmitButton'] = true;
        }
        else {
          this.currentQuesData['enableSubmitButton'] = false;
        }
      }
    }
    else {
      if (this.currentQuesData["questiontype"] == "OT" && this.currentQuesData["useranswer"]["useruploadimg"] != "") {
        this.currentQuesData['enableSubmitButton'] = true;
      }
      else {
        this.currentQuesData['enableSubmitButton'] = false;
      }
    }
  }

  okMdl() {
    this.showMdlObj.show = false;
    this.showMdlObj.msg = "";
    if (this.modalCondition == "testFinished") {
      this.showLoader = true;

      this.modalCondition = "";
      let params =
      {
        "userid": this.encryptService.encrypt(this.dataManipSrvc.userId + ""),
        "usertestid": this.encryptService.encrypt(this.dataManipSrvc.usertestid + ""),
        "testid": this.encryptService.encrypt(this.dataManipSrvc.testId + "")
      };
      let apiUrl = this.configSetting.getBaseUrl() + "dashtest/downloadResultPDF";
      this.commonServices.downloadReport(apiUrl, params).subscribe(successResp => {

        var blob = new Blob([successResp], { type: 'application/pdf' });
        var url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");

        // let testDate = this.datePipe.transform(this.userTests[i]["testcompleted"][j]["testcompletedon"], "dd-MMM-yyyy");
        // let a = document.createElement('a');
        // document.body.appendChild(a);
        // a.setAttribute('style', 'display: none');
        // a.href = url;
        // a.download = this.userTests[i]["testname"]["testname"] + "_" + testDate;
        // a.click();
        // window.URL.revokeObjectURL(url);
        // a.remove();
        this.showLoader = false;
        // this.router.navigateByUrl("/dashboard");
        this.router.navigate(["/dashboard"], { queryParams: { testid: this.dataManipSrvc.testId, usertestid: this.dataManipSrvc.usertestid } });

      },
        err => {
          alert("Problem while downloading the file.");

          console.error(err);
        }
      );
      // var url = this.configSetting.getBaseUrl() + "pdf/" + this.filePath;
      // window.open(url, "_blank");
      // this.router.navigateByUrl("/dashboard");


      // if (this.dataManipSrvc.testId == 4) {
      //   this.sendMail();
      // }
      // else {
      //   this.router.navigateByUrl("/dashboard");
      // }
    }
    else {
      if (this.modalCondition == "mailsent") {
        this.modalCondition = "";
        this.router.navigateByUrl("/dashboard");
      }
    }

  }

  sendMail() {
    this.showloader = true;
    this.trasparentmodal.msg = "Saving your test and preparing your result. Please wait";
    this.trasparentmodal.show = true;
    // this.objservice.loaderMsg = "Saving your test and preparing your result. Please wait";

    // this.loaderTimeOut();
    let apiUrl = this.configSetting.getBaseUrl() + "dashtest/sendMail";
    let obj = {};
    obj["userid"] = this.dataManipSrvc.userId;
    obj["testid"] = this.dataManipSrvc.testId;
    obj["usertestid"] = this.dataManipSrvc.usertestid;
    this.commonServices.postMethod(apiUrl, obj)
      .subscribe(
        (quesData) => {
          this.showloader = false;
          this.trasparentmodal.msg = "";
          // this.objservice.loaderMsg = "";
          this.trasparentmodal.show = false;
          this.modalCondition = "mailsent";
          if (quesData["errorCode"] == "000000") {
            // extra condition to satisfy show review on okMandatory


            //this.showMdlObj.msg = quesData["errorDescription"];
            this.showMdlObj.msg = "Check your mail to see result !";
            this.showMdlObj.show = true;
          }
          else {
            this.showloader = false;
            this.trasparentmodal.msg = "";
            this.trasparentmodal.show = false;
            console.error(" succ error ----------: " + quesData["errorDescription"]);
            this.showMdlObj.msg = quesData["errorDescription"]//Something went wrong. Please contact to admin.";//
            this.showMdlObj.show = true;
          }
        },
        err => {
          this.modalCondition = "mailsent";
          this.showloader = false;
          this.trasparentmodal.msg = "";
          this.trasparentmodal.show = false;
          //// console.log("erro in get question : ", err);
          // console.error("err error----------: " + err["errorDescription"]);

          this.showMdlObj.msg = this.messsages["EXCPT"]//Something went wrong. Please contact to admin.";//
          this.showMdlObj.show = true;
        })

  }

  disableCopyPasteOnTextarea(event) {
    event.preventDefault();
  }

  finishTrailTest(testObj) {
    console.log(testObj);
    this.testPaperList = [testObj]
    this.finishTest()
  }

}
